import React from "react";

const TRACK_COLOR = "#E1EAF0";
const RADIUS = 9.5;
const STROKE_WIDTH = 4;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const ProgressCircle = ({ percentage = 0, color, size = 24, complete = false }) => {
    const p = Math.min(100, Math.max(0, percentage));

    if (complete || p === 100) {
        return (
            <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="11.5" fill={color} />
                <path
                    d="M6.2501 12.612L9.44604 15.8079L17.2648 8.0277"
                    stroke="white"
                    strokeWidth="2.15625"
                    strokeLinejoin="round"
                />
            </svg>
        );
    }

    const offset = CIRCUMFERENCE - (p / 100) * CIRCUMFERENCE;

    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r={RADIUS} stroke={TRACK_COLOR} strokeWidth={STROKE_WIDTH} />
            {p > 0 && (
                <circle
                    cx="12"
                    cy="12"
                    r={RADIUS}
                    stroke={color}
                    strokeWidth={STROKE_WIDTH}
                    strokeLinecap="round"
                    strokeDasharray={CIRCUMFERENCE}
                    strokeDashoffset={offset}
                    transform="rotate(-90 12 12)"
                />
            )}
        </svg>
    );
};

export default ProgressCircle;
